<template>
	<form @submit.prevent="callRecaptcha">
		<div class="row">
			<div class="col-12">
				<grouped-erros :errors="errors" />
			</div>
		</div>

		<template v-if="loading">
			<div class="row justify-content-center mt-2 py-4">
				<div class="col-auto">
					<Loader :loading="loading" />
				</div>
			</div>
		</template>
		<template v-else>
			<div class="col-12">
				<div class="row">
					<div class="col-12">
						<textarea
							id="message"
							v-model="form.message"
							class="print form-control parametros_search light responsive-text-14 color-black py-2"
							type="text"
							style="height: 80px;"
							rows="3"
							name="message"
							required
						/>
					</div>
				</div>

				<div class="row mt-3" v-if="form.test!==null">
					<div class="col-md-6">
						<label for="senderName" class="defaultLabel medium">Nome</label>
						<input
							id="senderName"
							v-model="form.senderName"
							class="form-control parametros_search"
							type="text"
							name="senderName"
							required
						>
					</div>

					<div class="col-md-6">
						<label for="senderPhone" class="defaultLabel medium">Telefone</label>
						<input
							id="senderPhone"
							v-model="form.senderPhone"
							type="tel"
							class="form-control parametros_search"
							name="senderPhone"
							required
						>
					</div>
				</div>

				<div class="row mt-3" v-if="form.test!==null">
					<div class="col-12">
						<label for="senderEmail" class="defaultLabel medium">Email</label>
						<input
							id="senderEmail"
							v-model="form.senderEmail"
							type="email"
							class="form-control parametros_search"
							name="senderEmail"
							placeholder=""
							required
						>
					</div>
				</div>
                <div class="row my-3" v-if="form.test!==null">
                    <div class="col-12">
                        <div class="d-flex align-items-center">
                            <input
                                id="requestVisit"
                                v-model="form.requestVisit"
                                class="form-check-input"
                                style="margin-top: -5px;"
                                name="requestVisit"
                                type="checkbox"
                                value="1"
                            >
                            <label
                                class="use-as-small float-left inline responsive-text-14 defaultLabel regular pl-2 pb-0"
                                for="requestVisit"
                                style="letter-spacing: 0;"
                            >
                                Quero sugerir uma data e hora para visita.
                            </label>
                        </div>
                    </div>
                </div>

                <div class="row mt-3" v-if="form.requestVisit==1">
                    <div class="col-md-6">
                        <label for="visitDay">
                            Dia
                        </label>
                        <input type="date" v-model="form.visitDay" name="visitDay" class="form-control" id="visitDay" />
                    </div>
                    <div class="col-md-6">
                        <label for="hourDay">
                            Hora
                        </label>
                        <input type="time" v-model="form.hourDay" name="hourDay" class="form-control" id="hourDay"/>
                    </div>
                </div>
                <div class="row my-3" v-if="form.test!==null">
                    <div class="col-12">
                        <div class="d-flex align-items-center">
                            <input
                                id="sendEmailToSender"
                                v-model="form.sendEmailToSender"
                                class="form-check-input"
                                style="margin-top: -5px;"
                                name="sendEmailToSender"
                                type="checkbox"
                                value="1"
                            >
                            <label
                                class="use-as-small float-left inline responsive-text-14 defaultLabel regular pl-2 pb-0"
                                for="sendEmailToSender"
                                style="letter-spacing: 0;"
                            >
                                Quero receber um email com este pedido.
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row my-3" v-if="form.test!==null">
					<div class="col-12">
						<div class="d-flex align-items-center">
							<input
								id="your-consent-contacto"
								v-model="form.consent"
								class="form-check-input"
								style="margin-top: -5px;"
								name="consent"
								type="checkbox"
								value="1"
								required
							>
							<label
								class="use-as-small float-left inline responsive-text-14 defaultLabel regular pl-2 pb-0"
								for="your-consent-contacto"
								style="letter-spacing: 0;"
							>
								Aceito os
								<a :href="route('termsConditions')" target="_blank">
									<u><b>Termos e Condições</b></u>
								</a>
								e a <a :href="route('politicaPrivacidade')" target="_blank">
									<u><b>Política de privacidade</b></u>
								</a>.*
							</label>
						</div>
					</div>
				</div>

				<div class="row" v-if="form.test!==null">
					<div class="col-12 pb-2 mb-2">
						<button
							id="btnContact"
							type="submit"
							class="btn btn-primary col-12 no-padding text-18 bold"
							:disabled="loading"
						>
							Enviar
						</button>
					</div>
				</div>
                <div class="row" v-else>
                    <div class="col-12 pb-2 mt-2 mb-2">
                        <div
                            id="btnContact"
                            class="btn btn-primary col-12 no-padding text-18 bold"
                            @click="form.test=true"
                        >
                            Contactar
                        </div>
                    </div>
                </div>
			</div>
		</template>

		<Recaptcha
			ref="recaptcha"
			@verify="setCaptcha"
			@rendered="setToken"
		/>
	</form>
</template>
<script>
import {formatterErrorsLaravel} from "@/pages/publicpages/realestate/modal-save-search";
import GroupedErros from "@/vue/components/GroupedErrors";
import Loader from "@/vue/components/Loader";
import Recaptcha from "@/vue/components/Recaptcha";

export default {
    name: 'FormContact',
    components: {Recaptcha, GroupedErros, Loader},
    props: {
        endpoint: {
            type: String,
            required: true,
        },
        modalIdentifier: {
            type: [String, null],
            required: false,
            default: null,
        },
        propertyId: {
            type: [Number, null],
            required: false,
            default: null,
        },
    },
    data() {
        return {
            form: {
                hourDay: null,
                visitDay: null,
                requestVisit:null,
                test:null,
                senderName: null,
                senderEmail: null,
                senderPhone: null,
                consent: false,
                'g-recaptcha-response': null,
                page_url: null,
                sendEmailToSender: false,
                message: "Estou interessado neste imóvel e gostaria de mais obter mais informações antes de marcar uma visita.",
                captcha: null,
            },
            errors: [],
            loading: false
        }
    },
    computed: {
        siteKey() {
            let el = document.querySelector('input[name=siteKey]')
            if (el) {
                return JSON.parse(el.value)
            }

            return process.env.MIX_INVISIBLE_RECAPTCHA_SITEKEY
        },
        fullUrl() {
            return window.location.href
        },
        requiredCaptcha(){
            //É uma forma de saber se ouser está logado
            //Não deixei a variável com um nome óbvio, pois fica exposto ao público
            //De qualquer forma, tem outra validação no servidor
            return JSON.parse(sessionStorage.getItem('_form'))
        }
    },
    mounted() {
        this.form.page_url = this.fullUrl
        this.recoveryDataFromSessionStorage()
    },
    methods: {
        async submit() {
            this.loading = true;
            this.errors = [];

            //Hammered by Rafa, if exists an easier option pls contact me on Teams or Whatsapp
            if(this.propertyId){
                this.form.propertyId = this.propertyId;
            }

            return axios.post(this.endpoint, this.form).then(({data}) => {
                // CCERTA-2883: o GTM passa a disparar o fale_conosco neste evento (envio real),
                // em vez do page view de qualquer URL com /contact, que os bots disparavam.
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({event: 'contact_request_sent', property_id: this.propertyId || null});

                if (this.modalIdentifier) {
                    const myModalEl = document.querySelector(this.modalIdentifier)
                    const myModal = bootstrap.Modal.getInstance(myModalEl)
                    myModal.hide();
                }

                //Reset form
                this.form.senderName = null;
                this.form.senderEmail = null;
                this.form.senderPhone = null;

                // Mostrar modal de sucesso v3
                const successModal = document.querySelector('#contactSuccessModal');
                if (successModal) {
                    const modal = new bootstrap.Modal(successModal);
                    modal.show();
                } else {
                    // Fallback: Swal centered modal
                    Swal.fire({
                        title: 'Mensagem enviada!',
                        text: 'A sua mensagem foi encaminhada com sucesso para o anunciante.',
                        icon: 'success',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#059669',
                    });
                }

                return Promise.resolve()
            }).catch((e) => {
                this.errors = formatterErrorsLaravel(e)
                return Promise.reject(e)
            }).finally(() => {
                //Faço isso pra manter a última informação do user
                sessionStorage.setItem('me', JSON.stringify({
                    name: this.form.senderName,
                    phone: this.form.senderPhone,
                    email: this.form.senderEmail,
                }))

                this.loading = false;
                this.$refs.recaptcha.reset()
            })
        },
        setCaptcha(token) {
            this.form['g-recaptcha-response'] = token
            this.form.captcha = 'recaptcha'
            this.submit()
        },
        callRecaptcha() {
            //Caso o user esta authenticado, não é necessário o recaptcha
            if (this.requiredCaptcha && this.form.captcha === 'recaptcha') {
                return this.$refs.recaptcha.execute()
            }

            return this.submit()
        },
        recoveryDataFromSessionStorage(){
            //Faço isso pra manter a última informação do user
            let me = document.querySelector('#me')?.value

            if (me) {
                me = JSON.parse(me)

                if (me.hasOwnProperty('name')) {
                    this.form.senderName = me.name
                }

                if (me.hasOwnProperty('phone')) {
                    this.form.senderPhone = me.phone
                }

                if (me.hasOwnProperty('email')) {
                    this.form.senderEmail = me.email
                }
            }
        },
        setToken(token){
            this.form['g-recaptcha-response'] = token
            this.form.captcha = 'turnstile';
        }
    },
}
</script>
